import { SearchModel, StorageHelper } from '@smg-real-estate/hg-search-libs';

import { HgLocalStorageKey } from '@/models';

import { StorageNamespace } from '../storage-namespaces';

let searchResultStorage: StorageHelper | null = null;

function getSearchResultStorage(): StorageHelper {
  if (!searchResultStorage) {
    searchResultStorage = new StorageHelper(StorageNamespace.searchResults);
  }

  return searchResultStorage;
}

export function getLastSearch(): SearchModel | null {
  return getSearchResultStorage().getSessionStorageItem(HgLocalStorageKey.LAST_SEARCH_MODELS);
}

export function setLastSearch(lastSearches: SearchModel): void {
  getSearchResultStorage().setSessionStorageItem(
    HgLocalStorageKey.LAST_SEARCH_MODELS,
    lastSearches,
  );
}

export function removeLastSearch(): void {
  getSearchResultStorage().removeSessionStorageItem(HgLocalStorageKey.LAST_SEARCH_MODELS);
}
